<template lang="pug">
  v-dialog(
    v-model="dialog"
    eager
    max-width="400"
  )
    v-card
      v-toolbar(dense flat color="green" dark)
        span Change Supplier: 
        span.ml-2.text-decoration-underline {{ supplierProduct.product_name }} 
      v-container
        v-row
          v-col(cols="12")
            v-autocomplete(
              label="supplier"
              v-model="supplierId"
              :items="supplierIndexList"
              item-text="name"
              item-value="id"
              hide-details="auto"
              outlined
              no-filter
              :search-input.sync="supplierSearch"
            )
              template(v-slot:selection="{ item }")
                span {{ item.id }} - {{ item.name }}
              template(v-slot:item="{ item }")
                span {{ item.id }} - {{ item.name }}
          v-col(cols="6")
            v-btn(
              color="green"
              dark
              block
              dense
              @click="transferSupplierProduct"
              :loading="supplierProductTransferPosting"
            ) Transfer
          v-col(cols="6")
            v-btn(
              color="red"
              dark
              block
              dense
              @click="cancel"
            ) Cancel
</template>
<script>
  import supplierProductRepository from '@/repositories/supplier-product.repository'
  import supplierRepository from '@/repositories/supplier.repository'
  import VueRequestHandler from '@/classes/VueRequestHandler.class'
  import requestVars from '@/extra-functions/request-vars.extra'

  const [supplierIndexVars, supplierIndexVarNames] = requestVars({ identifier: 'supplier-index' })
  const [supplierProductTransferVars, supplierProductTransferVarNames] = requestVars({ identifier: 'supplier-product-transfer', hasData: false, request: 'post' })

  const supplierIndexHandler = new VueRequestHandler(null, supplierIndexVarNames) 
  const supplierProductTransferHandler = new VueRequestHandler(null, supplierProductTransferVarNames)

  export default {
    name: 'ChangeSupplier',
    data () {
      return {
        ...supplierIndexVars,
        ...supplierProductTransferVars,
        dialog: false,
        supplierId: null,
        supplierSearch: null,
        supplierProduct: {},
      }
    },
    watch: {
      supplierSearch () {
        this.getSupplierIndex()
      },
    },
    created () {
      this.getSupplierIndex()
    },
    methods: {
      async getSupplierIndex () {
        try {
          const handler = supplierIndexHandler
          const repository = supplierRepository.index
          const params = { search: this.supplierSearch }
          const range = [0, 1000]
          handler.setVue(this)
          await handler.execute(repository, [range, params])
        } catch (e) {
          alert(e.message)
        }
      },
      async transferSupplierProduct () {
        try {
          const handler = supplierProductTransferHandler
          const repository = supplierProductRepository.transfer
          handler.setVue(this)
          await handler.execute(repository, [this.supplierProduct.id, { supplier_id: this.supplierId }])
          this.supplierId = null
          this.cancel()
        } catch (e) {
          alert(e.message)
        }
      },
      open () {
        this.dialog = true
      },
      setSupplierProduct (supplierProduct) {
        this.supplierProduct = supplierProduct
      },
      cancel () {
        this.supplierProduct = {}
        this.dialog = false
      },
    },
  }
</script>
